import axios from "axios";
import { config } from "./config";

export const api = axios.create({ baseURL: config.apiUrl, withCredentials: true, timeout: 20000 });

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  if (!e?.response) return "Network error. Check your connection and try again.";
  const d = e.response.data?.detail;
  if (Array.isArray(d)) return d.map((x) => (x.msg || "").replace(/^Value error, /, "")).join(" ");
  return typeof d === "string" ? d : fallback;
}
